import { useEffect } from "react";

import { DeliveryMethod, OrderFields } from "../../constants";
import useOrderData from "../../context/useOrderData";
import useOrderFormik from "../useOrderFormik";

const fieldName = OrderFields.DELIVERY_METHOD;

const useDefaultDeliveryMethod = (): void => {
  const {
    values: { [fieldName]: currentValue },
    setFieldValue,
    setFieldError,
  } = useOrderFormik();

  const {
    staticData: { deliveryMethods },
    dynamicData: { offers },
  } = useOrderData();

  const deliveryMethodsInOffers = offers.map(({ deliveryMethod }) => deliveryMethod);
  const defaultDeliveryMethod = deliveryMethods.find(({ value }) => deliveryMethodsInOffers.includes(value))?.value;

  // If current value is not set, and there are available values - set to the first not disabled value as default
  useEffect(() => {
    if (!currentValue && defaultDeliveryMethod) {
      setFieldValue(fieldName, defaultDeliveryMethod);
      setFieldError(fieldName, undefined);
    }
  }, [currentValue, defaultDeliveryMethod, setFieldError, setFieldValue]);

  // Check if current value is disabled, if yes, set current value to the first not disabled value
  useEffect(() => {
    if (currentValue && !deliveryMethodsInOffers.includes(currentValue as DeliveryMethod)) {
      setFieldValue(fieldName, defaultDeliveryMethod || null);
      setFieldError(fieldName, undefined);
    }
  }, [currentValue, defaultDeliveryMethod, deliveryMethodsInOffers, setFieldError, setFieldValue]);
};
export default useDefaultDeliveryMethod;
